<template>
    <PaginatedResource
        ref="stylesheetRes"
        :fetch-method="fetchStylesheetResults"
        :filter-fields="filter"
        delay-fetch
    >
        <template #default="{ loading, resource: results, isEmpty, notFound, search }">
            <div class="book-nav__stylesheet">
                <SearchInput :placeholder="$t('misc.search')" @change="search" />
                <ul>
                    <li v-for="(item, i) in results" :key="`stylesheet-${i}`">
                        <div>
                            <strong v-t="'stylesheet.resultsShort.word'" />
                            <button
                                v-t="item.target"
                                class="button button--blank"
                                @click="$emit('styleSheetItemClick', item.target)"
                            />
                        </div>
                        <div>
                            <strong v-t="'stylesheet.resultsShort.explanation'" />
                            <span v-t="item.explanation" />
                        </div>
                    </li>
                </ul>
                <Spinner v-if="loading" />
                <div v-if="!loading && (isEmpty || notFound)" class="book-nav__stylesheet-nodata">
                    <span v-t="'stylesheet.noData'" />
                </div>
            </div>
        </template>
    </PaginatedResource>
</template>
<script>
import { fetchStylesheetResults } from '../../api/stylesheet';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import { SearchInput } from '@speechki-frontend/shared/ui/forms';
import { mapState } from 'vuex';

export default {
    name: 'StylesheetList',
    emits: ['styleSheetItemClick'],
    components: {
        PaginatedResource,
        SearchInput
    },
    computed: {
        ...mapState({
            book: state => state.book.book
        }),
        filter() {
            const { search } = this;
            return { search, book: this.book.id };
        }
    },
    watch: {
        book() {
            this.$refs.stylesheetRes.filter(this.filter);
        }
    },
    methods: {
        fetchStylesheetResults,

        scroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            if (this.$refs.stylesheetRes.loading) return false;
            if (scrollTop + clientHeight >= scrollHeight) {
                const { stylesheetRes } = this.$refs;
                if (stylesheetRes.canLoadMore) {
                    stylesheetRes.loadMore();
                }
            }
        }
    }
};
</script>
